import React from 'react';
import { theme, cardStyle, inputStyle, btnStyle, tdStyle, thStyle } from '../theme';
import { STATUS_CONFIG } from '../constants';

/**
 * Appointments tab — quick book form + list of all appointments.
 */
const AppointmentsPage = ({ appointmentsList, appointmentForm, setAppointmentForm, handleBookAppointment }) => {
  return (
    <div style={{display:'grid', gridTemplateColumns:'1fr 2fr', gap:'24px', alignItems:'flex-start'}}>
      {/* Quick Book Form */}
      <div style={cardStyle}>
        <h3 style={{margin:'0 0 16px', color:theme.navy, fontSize:'1.1rem', fontWeight:'700'}}>Book Appointment</h3>
        <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
          <input placeholder="Patient name"
            value={appointmentForm.patientName}
            onChange={e=>setAppointmentForm({...appointmentForm, patientName:e.target.value})}
            style={inputStyle}/>
          <input placeholder="Phone"
            value={appointmentForm.phone}
            onChange={e=>setAppointmentForm({...appointmentForm, phone:e.target.value})}
            style={inputStyle}/>
          <input type="date"
            value={appointmentForm.date}
            onChange={e=>setAppointmentForm({...appointmentForm, date:e.target.value})}
            style={inputStyle}/>
          <input type="time"
            value={appointmentForm.time}
            onChange={e=>setAppointmentForm({...appointmentForm, time:e.target.value})}
            style={inputStyle}/>
          <input placeholder="Treatment (optional)"
            value={appointmentForm.treatment}
            onChange={e=>setAppointmentForm({...appointmentForm, treatment:e.target.value})}
            style={inputStyle}/>
          <button onClick={handleBookAppointment} style={{...btnStyle, marginTop:'8px', width:'100%', justifyContent:'center'}}>
            Book Now
          </button>
        </div>
      </div>

      {/* List */}
      <div style={cardStyle}>
        <h3 style={{margin:'0 0 16px', color:theme.navy, fontSize:'1.1rem', fontWeight:'700'}}>All Appointments</h3>
        {appointmentsList.length === 0 ? (
          <p style={{color:theme.textMuted, fontSize:'0.88rem'}}>No appointments yet.</p>
        ) : (
          <table style={{width:'100%', borderCollapse:'collapse'}}>
            <thead>
              <tr>
                <th style={thStyle}>Date</th>
                <th style={thStyle}>Time</th>
                <th style={thStyle}>Patient</th>
                <th style={thStyle}>Phone</th>
                <th style={thStyle}>Treatment</th>
                <th style={thStyle}>Status</th>
              </tr>
            </thead>
            <tbody>
              {appointmentsList
                .slice()
                .sort((a,b)=> (a.date+a.time) > (b.date+b.time) ? -1 : 1)
                .slice(0, 50)
                .map(a => {
                  const cfg = STATUS_CONFIG[a.status] || STATUS_CONFIG['Scheduled'];
                  return (
                    <tr key={a._id}>
                      <td style={tdStyle}>{a.date}</td>
                      <td style={tdStyle}>{a.time}</td>
                      <td style={tdStyle}><strong>{a.patientName}</strong></td>
                      <td style={tdStyle}>{a.phone || '—'}</td>
                      <td style={tdStyle}>{a.treatment || '—'}</td>
                      <td style={tdStyle}>
                        <span style={{
                          padding:'3px 10px', borderRadius:'12px', fontSize:'0.74rem', fontWeight:'700',
                          backgroundColor: cfg.bg, color: cfg.textColor,
                        }}>
                          {cfg.icon} {a.status}
                        </span>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AppointmentsPage;
